import { render } from "./CalendarForm.vue?vue&type=template&id=e23b04a2"
import script from "./CalendarForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/CalendarForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e23b04a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e23b04a2', __exports__)) {
    api.reload('e23b04a2', __exports__)
  }
  
  module.hot.accept("./CalendarForm.vue?vue&type=template&id=e23b04a2", () => {
    api.rerender('e23b04a2', render)
  })

}


export default __exports__